"use strict";

var _requester = require("./requester");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.VariableType = exports.TrackingStatus = exports.Milliseconds = exports.Environment = void 0;
var Environment = exports.Environment = function (a) {
    return a.Production = "production", a.Staging = "staging", a.Development = "development", a;
  }({}),
  VariableType = exports.VariableType = function (a) {
    return a.BOOLEAN = "BOOLEAN", a.NUMBER = "NUMBER", a.STRING = "STRING", a.JSON = "JSON", a.JS = "JS", a.CSS = "CSS", a;
  }({}),
  TrackingStatus = exports.TrackingStatus = function (a) {
    return a.Sent = "sent", a.Unsent = "unsent", a.Pending = "pending", a;
  }({}),
  Milliseconds = exports.Milliseconds = function (a) {
    return a[a.Second = 1000] = "Second", a[a.Minute = 60 * a.Second] = "Minute", a[a.Hour = 60 * a.Minute] = "Hour", a[a.Day = 24 * a.Hour] = "Day", a[a.Week = 7 * a.Day] = "Week", a[a.Month = 30 * a.Day] = "Month", a;
  }({});